"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("react-date-range/dist/styles.css");
require("react-date-range/dist/theme/default.css");
var rdrLocales = _interopRequireWildcard(require("react-date-range/dist/locale"));
var _reactDateRange = require("react-date-range");
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// main style file

// theme css file

class DateCalendar extends _react.default.Component {
  render() {
    const {
      value,
      onChange,
      minDate,
      maxDate
    } = this.props;
    let minDateISO;
    let maxDateISO;
    let selectedDate;
    minDate ? minDateISO = (0, _parseISO.default)(minDate) : minDateISO = (0, _parseISO.default)('1945-09-01T23:00:00.000Z');
    maxDate ? maxDateISO = (0, _parseISO.default)(maxDate) : maxDateISO = (0, _parseISO.default)('2045-09-01T23:00:00.000Z');
    value ? selectedDate = (0, _parseISO.default)(value) : selectedDate = Date.now();
    return /*#__PURE__*/_react.default.createElement(_reactDateRange.Calendar, {
      date: selectedDate,
      onChange: value => onChange(value.toISOString()),
      minDate: minDateISO,
      maxDate: maxDateISO,
      locale: rdrLocales['enGB']
    });
  }
}
var _default = exports.default = DateCalendar;
module.exports = exports.default;